
import { useState, useEffect } from 'react';

const slides = [
  {
    image: 'https://static.readdy.ai/image/4bc9de6e210205b75e4b5b67d3d29f64/e3e9014bc640c0887ed0808593fd3170.jfif',
    title: 'Welcome to ATENA',
    subtitle: '神戸三宮最高級のおもてなし'
  },
  {
    image: 'https://static.readdy.ai/image/4bc9de6e210205b75e4b5b67d3d29f64/c6318462511324fa1a6bd610946ec44c.jfif',
    title: 'Premium Experience',
    subtitle: '特別な夜をお約束'
  },
  {
    image: 'https://static.readdy.ai/image/4bc9de6e210205b75e4b5b67d3d29f64/559435805909834101e079af9a761e91.jfif',
    title: 'Elegant Bar',
    subtitle: '洗練されたバーエリア'
  },
  {
    image: 'https://static.readdy.ai/image/4bc9de6e210205b75e4b5b67d3d29f64/20a193cb2da511e9acf0a1ee3c28ab59.jfif',
    title: 'VIP Lounge',
    subtitle: '豪華なVIPラウンジ'
  },
  {
    image: 'https://static.readdy.ai/image/4bc9de6e210205b75e4b5b67d3d29f64/d42116c4681277459b7cfb3c5c9cd558.jfif',
    title: 'Private Room',
    subtitle: 'プライベート個室'
  }
];

export default function HeroSlideshow() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative h-screen overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>
      ))}

      <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
        <div className="text-center text-white px-4">
          <img
            src="https://static.readdy.ai/image/4bc9de6e210205b75e4b5b67d3d29f64/8be71bd4b69f605f526d3a0b1405a296.png"
            alt="ATENA Logo"
            className="w-[30%] h-auto mx-auto mb-6"
          />
          <p className="text-xl md:text-2xl mb-8 max-w-2xl mx-auto">
            神戸初2フロア展開のラグジュアリーなホストクラブ
          </p>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide ? 'bg-blue-500' : 'bg-white/50'
            }`}
          />
        ))}
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 translate-y-16">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-2xl"></i>
        </div>
      </div>
    </div>
  );
}
